import mechanical from "../assets/mechanical.svg"
import electrical from "../assets/electric.svg"
import plumbing from "../assets/plumbing.svg"
import fire from "../assets/fire.svg"
import { RoleHierarchy, Roles } from "../interfaces/employee_type"

// just a small helper function to get the icon for the category
export const categoryIcon = (category: string) => {
    if (category === 'Mechanical') return mechanical
    else if (category === 'Electrical') return electrical
    else if (category === 'Plumbing') return plumbing
    else if (category === 'Fire Protection') return fire
    else return null
}

/**
 * Checks which hierarchy group the employee role belongs to
 *
 * @param role - The role to check (e.g. "CEO", "Manager", etc.)
 * @returns The hierarchy key (e.g. "ADMIN", "MANAGERS", etc.) or "TEAM" as default
 * 
 * You can check the RoleHierarchy object in the employee_type.ts file
 */

export function checkEmployeeHierarchy(role: string): keyof typeof RoleHierarchy {
    // Convert role to proper case to match EMPLOYEE_ROLES format
    const formattedRole = role

    // Check each hierarchy group for the role
    for (const [key, roles] of Object.entries(RoleHierarchy)) {
        if (roles.includes(formattedRole as Roles)) {
            return key as keyof typeof RoleHierarchy
        }
    }
    
    // Default to "TEAM" if role is not found
    return "TEAM"
}
